import { FC } from 'react';
import { Box, Flex, Palette, Text } from '@updater/ui-uds';
import styled from '@emotion/styled';
import { SortPill, SORT_PILL_LABELS } from 'constants/sortPills';

const PillButton = styled.button<{ $active: boolean }>`
  background: ${({ $active }) => ($active ? Palette.gray900 : 'transparent')};
  color: ${({ $active }) => ($active ? Palette.white : Palette.gray700)};
  border: 1px solid
    ${({ $active }) => ($active ? Palette.gray900 : Palette.gray300)};
  border-radius: ${({ theme }) => theme.radii.full};
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${Palette.gray900};
    outline-offset: 2px;
  }

  &:hover {
    border-color: ${({ $active }) =>
      $active ? Palette.gray900 : Palette.gray600};
  }
`;

const PILLS = [
  SortPill.Recommended,
  SortPill.Speed,
  SortPill.BestValue,
  SortPill.Price,
] as const;

interface SortPillsProps {
  activePill: SortPill;
  onChange: (pill: SortPill) => void;
}

export const SortPills: FC<SortPillsProps> = ({ activePill, onChange }) => (
  <Box mb="m">
    <Flex gap="xs" flexWrap="wrap">
      {PILLS.map((pill) => (
        <PillButton
          key={pill}
          $active={activePill === pill}
          onClick={() => onChange(pill)}
          type="button"
        >
          <Text as="span" variant="s" color="inherit">
            {SORT_PILL_LABELS[pill]}
          </Text>
        </PillButton>
      ))}
    </Flex>
  </Box>
);
